<template>
    <svg :class="svgClass" v-bind="$listeners" :style="{ color: color }">
        <use :xlink:href="iconName" />
    </svg>
</template>

<script>
    export default {
        name: 'SvgIcon',
        props: {
            name: {
                type: String,
                required: true,
            },
            color: {
                type: String,
                default: '',
            },
        },
        computed: {
            iconName() {
                return `#icon-${this.name}`;
            },
            svgClass() {
                if (this.name) {
                    return `svg-icon icon-${this.name}`;
                }
                return 'svg-icon';
            },
        },
    };
</script>

<style lang="less">
    .svg-icon {
        width: 1em;
        height: 1em;
        fill: currentColor;
        vertical-align: middle;
    }
</style>
